import {ReactComponent as MailIcon} from '../../../assets/header/mail.svg';
import {ReactComponent as PhoneIcon} from '../../../assets/header/phone.svg';
import {ReactComponent as AppIcon} from '../../../assets/header/app.svg';
import {CONTACT_EMAIL, CONTACT_PHONE} from "entities/constants/constants";

export const headerItems = [
    {
        icon: <MailIcon />,
        title: CONTACT_EMAIL,
        link: `mailto:${CONTACT_EMAIL}`,
        userType: 'all',
    },
    {
        icon: <PhoneIcon />,
        title: 'Администратор',
        tell: CONTACT_PHONE,
        path: `tel:${CONTACT_PHONE}`,
        userType: 'all',
    },
    {
        icon: <AppIcon />,
        appText: 'Установить сайт на смартфон/десктоп',
        userType: 'all',
    },
];
